<div class="mb-3x">
  <form *ngIf="!enableWeitereAngabenJuristischePerson" [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="geburtsdatum{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.PERSON_EXTENDED.GEBURTSDATUM' | translate }}</label>
      <div class="col-sm-8">
        <date-picker
                id="geburtsdatum{{index}}"
                messagePath="geburtsdatum{{objectId}}"
                formControlName="geburtsdatum"
                [isRequired]=true>
        </date-picker>
      </div>
    </div>
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="beruflicheTaetigkeit{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.PERSON_EXTENDED.BERUFLICHE_TAETIGKEIT' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="beruflicheTaetigkeit{{objectId}}" formControlName="beruflicheTaetigkeit"
               id="beruflicheTaetigkeit{{index}}"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="identifikationsnummer{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.PERSON_EXTENDED.IDENTIFIKATIONSNUMMER' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="identifikationsnummer{{objectId}}" formControlName="identifikationsnummer"
               id="identifikationsnummer{{index}}"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>
  </form>
  <form *ngIf="enableWeitereAngabenJuristischePerson" [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="artDesBetriebes{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.PERSON_EXTENDED.ART_DES_BETRIEBES' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="artDesBetriebes{{objectId}}" formControlName="artDesBetriebes" id="artDesBetriebes{{index}}"
               type="text"
               utilsCheckValidity utilsControlState utilsValidationMessage/>
      </div>
    </div>
  </form>
</div>

